import { render } from "./commonPatientShareTemplate.vue?vue&type=template&id=a8023ac8"
import script from "./commonPatientShareTemplate.vue?vue&type=script&lang=js"
export * from "./commonPatientShareTemplate.vue?vue&type=script&lang=js"

import "./commonPatientShareTemplate.vue?vue&type=style&index=0&id=a8023ac8&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__